import React from 'react';
import '../App.css';

function Statistics({ stats }) {
  if (!stats) {
    return <div className="statistics loading">Loading statistics...</div>;
  }

  const StatCard = ({ title, data }) => {
    return (
      <div className="stat-card">
        <h3>{title}</h3>
        <div className="stat-grid">
          <div className="stat-item">
            <span className="stat-label">Total Matches:</span>
            <span className="stat-value">{data.total.toLocaleString()}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Correct:</span>
            <span className="stat-value">{data.correct.toLocaleString()}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Actual Accuracy:</span>
            <span className="stat-value accuracy">{data.accuracy}%</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Predicted Accuracy:</span>
            <span className="stat-value predicted">{data.predicted_accuracy}%</span>
          </div>
          {data.top_30_metrics && (
            <>
              <div className="stat-item">
                <span className="stat-label">Top 30% Actual Accuracy:</span>
                <span className="stat-value accuracy">{data.top_30_metrics.actual}%</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Top 30% Predicted Accuracy:</span>
                <span className="stat-value predicted">{data.top_30_metrics.predicted}%</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const ConfidenceBucketCard = ({ title, data }) => {
    if (!data || !data.confidence_buckets) return null;

    const maxAccuracy = Math.max(...data.confidence_buckets.map(b => b.accuracy));

    return (
      <div className="confidence-bucket-card">
        <h3>{title}</h3>
        <div className="bucket-chart">
          {data.confidence_buckets.map((bucket, index) => (
            <div key={index} className="bucket-item">
              <div className="bucket-label">{bucket.label}</div>
              <div className="bucket-bar-container">
                <div
                  className="bucket-bar"
                  style={{ width: `${bucket.total > 0 ? (bucket.accuracy / maxAccuracy) * 100 : 0}%` }}
                >
                  <span className="bucket-bar-value">
                    {bucket.total > 0 ? `${bucket.accuracy}%` : 'N/A'}
                  </span>
                </div>
              </div>
              <div className="bucket-info">
                <span>{bucket.correct}/{bucket.total}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="statistics">
      <div className="statistics-header">
        <h1>Model Statistics</h1>
        <p className="subtitle">Comprehensive accuracy metrics across all predictions</p>
      </div>

      <div className="stats-grid">
        <StatCard title="Overall Performance" data={stats.overall} />
        <StatCard title="Training Set" data={stats.train} />
        <StatCard title="Test Set" data={stats.test} />
      </div>

      <div className="confidence-buckets-section">
        <h2>Accuracy by Confidence Level</h2>
        <div className="confidence-buckets-grid">
          <ConfidenceBucketCard title="Overall" data={stats.overall} />
          <ConfidenceBucketCard title="Training Set" data={stats.train} />
          <ConfidenceBucketCard title="Test Set" data={stats.test} />
        </div>
      </div>

      <div className="stats-info">
        <h3>About These Metrics</h3>
        <div className="info-grid">
          <div className="info-item">
            <strong>Actual Accuracy:</strong> Percentage of matches where the model correctly predicted the winner
          </div>
          <div className="info-item">
            <strong>Predicted Accuracy:</strong> Average confidence level of the model's predictions
          </div>
          <div className="info-item">
            <strong>Top 30% Metrics:</strong> Performance on the 30% most confident predictions.
            Higher accuracy on confident predictions indicates good calibration.
          </div>
          <div className="info-item">
            <strong>Confidence Buckets:</strong> Accuracy broken down by prediction confidence levels.
            Well-calibrated models show higher accuracy in higher confidence buckets.
          </div>
        </div>
      </div>

      <div className="stats-footer">
        <p>Total Rounds: {stats.total_rounds} | Total Matches: {stats.total_matches.toLocaleString()}</p>
      </div>
    </div>
  );
}

export default Statistics;
